// extracted by mini-css-extract-plugin
export default {"fields":"GeneralInformationFields_fields__Txu2i","inputTotalSuffix":"GeneralInformationFields_inputTotalSuffix__OIPHa"};